import { store } from "../../..";
import { API } from "../../../../legacy/api";
import * as validate from "../../../validation";
import * as actions from "../../TickerDisplay/Common/TickerDisplay.actions";
import { InGameMessage } from "./TickerDisplay.actions";

API.on("ticker.message.set", (message: string | InGameMessage[]) => {
  if (validate.tickerMessage(message)) {
    store.dispatch(actions.setTickerMessage(message));
  }
});

API.on("ticker.show", () => {
  const hidden = store.getState().ticker.hidden;

  if (hidden) {
    store.dispatch(actions.setTickerHidden(false));
  }
});

API.on("ticker.hide", () => {
  const hidden = store.getState().ticker.hidden;

  if (!hidden) {
    store.dispatch(actions.setTickerHidden(true));
  }
});

API.on("ticker.animation.start", () => {
  const animationStopped = store.getState().ticker.animationStopped;

  if (animationStopped) {
    store.dispatch(actions.setAnimationStopped(false));
  }
});

API.on("ticker.animation.stop", () => {
  const animationStopped = store.getState().ticker.animationStopped;

  if (!animationStopped) {
    store.dispatch(actions.setAnimationStopped(true));
  }
});
